import Header from "../components/header";
import { useSelector } from "react-redux";
import BoxStatistics from "../components/common/boxStatistics";
import { useTranslation } from "react-i18next";
import BoxStatisticsDownload from "../components/common/boxStatisticsDownload";
import { useStatistics } from "../hooks/useStatistics";

const Statistics = () => {
  const { user } = useSelector((state: any) => state.login);
  const { t } = useTranslation();

  const { data: pharmacies } = useStatistics('pharmacies');
  const { data: attendances } = useStatistics('attendances');
  const { data: attendancesCitizens } = useStatistics('attendances-citizens');
  const { data: attendancesPharmacist } = useStatistics('attendances-pharmacist');
  const { data: pharmaciesHaveLeastAgenda } = useStatistics('pharmacies-have-least-agenda');
  const { data: overallAgendas } = useStatistics('overall-agendas');
  const { data: activeAgendas } = useStatistics('active-agendas');

  return (
    <>
      <Header active={true} titleLogOut={user?.username} />

      <div className="Section">
        <div className="row m-0">
          <div className="col-lg-6">
            <BoxStatistics
              value={pharmacies}
              label={t('statistics.total-registered-pharmacies')}
              color="#F6A500"
              icon="local_pharmacy"
            />
          </div>
          <div className="col-lg-6">
            <BoxStatistics
              value={pharmaciesHaveLeastAgenda}
              label={t('statistics.pharmacies-have-least-agenda')}
              color="#B620E0"
              icon="event"
            />
          </div>
          <div className="col-lg-6">
            <BoxStatistics
              value={overallAgendas}
              label={t('statistics.total-agendas-created')}
              color="#D81645"
              icon="calendar_month"
            />
          </div>
          <div className="col-lg-6">
            <BoxStatistics
              value={activeAgendas}
              label={t('statistics.active-agendas')}
              color="#92BC02"
              icon="event_upcoming"
            />
          </div>
          <div className="col-lg-4">
            <BoxStatistics
              value={attendances}
              label={t('statistics.total-reservations')}
              color="#5FB5EB"
              icon="event_available"
            />
          </div>
          <div className="col-lg-4">
            <BoxStatistics
              value={attendancesPharmacist}
              label={t('statistics.reservations-pharmacists')}
              color="#0091FF"
              icon="medical_information"
            />
          </div>
          <div className="col-lg-4">
            <BoxStatistics
              value={attendancesCitizens}
              label={t('statistics.reservations-citizens')}
              color="#44D7B6"
              icon="emoji_people"
            />
          </div>
          <div className="col-lg-4">
            <BoxStatisticsDownload
              color="transparent"
              icon="download"
            />
          </div>
        </div>
      </div>

    </>
  );
}

export default Statistics;
